import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";

interface MarkdownPageProps {
  content: string;
}

const MarkdownPage: React.FC<MarkdownPageProps> = ({ content }) => {
  return (
    <div className="cs-markdown-page">
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownPage;
